// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logout-form[data-v-12ef036d]{display:flex;flex-flow:column wrap;align-items:center}.logout-form h4[data-v-12ef036d]{margin-bottom:2rem}.logout-form .btn.btn-primary[data-v-12ef036d]{margin-top:1rem}.actions[data-v-12ef036d]{display:flex;flex-flow:row wrap;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
